import { create } from "zustand";

interface BuilderState {
  open: boolean;
  nodeId: string | null;
  openFor: (nodeId: string) => void;
  close: () => void;
}

export const useBuilderStore = create<BuilderState>((set) => ({
  open: false,
  nodeId: null,
  openFor: (nodeId) => set({ open: true, nodeId }),
  close: () => set({ open: false, nodeId: null }),
}));
